var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AgGridRenderList',{attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"totalRows":_vm.totalRows,"lastPage":_vm.lastPage,"loading":_vm.paginationLoading},on:{"grid-ready":_vm.onGridReady,"selection-changed":_vm.onSelectionChanged,"updatePagination":_vm.updatePagination,"updateItemPerPage":_vm.updateItemPerPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }